import { useEffect } from "react";

export default function useScrollLock(condition = true): void {
  useEffect(() => {
    if (condition) {
      document.querySelector("html")?.classList.add("scroll-lock");
      document.querySelector("body")?.classList.add("scroll-lock");
    } else {
      return;
    }

    return () => {
      document.querySelector("html")?.classList.remove("scroll-lock");
      document.querySelector("body")?.classList.remove("scroll-lock");
    };
  }, [condition]);
}
